import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { FC, useContext, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, styled } from "@mui/material";
import useCheckoutSession from "@/hooks/stripe/useCheckoutSession";
import Loading from "../common/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import AppSettingsContext from "@/contexts/AppSettingsContext";

const CancelButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: 4,
    right: 4,
    color: 'black',
}));



//const stripePromise = loadStripe(AppSettings.stripePublicKey);

interface StripePaymentProps 
{
    cost?: number;
    email?: string;
    handleStripePaymentComplete: (clientReferenceId?: string) => void;
    handleCancel: () => void;
}

const StripePayment: FC<StripePaymentProps> = ({
    cost,
    email,
    handleStripePaymentComplete,
    handleCancel
}) => {
    const {data: AppSettingsData} = useContext(AppSettingsContext);

    // as the initial is set from the call in index.html, this should be fine.
    const stripePromise = loadStripe(AppSettingsData?.stripePublicKey ?? '');

    const {data: data} = useCheckoutSession(cost ?? 0, email);
    const [openWarning, setOpenWarning] = useState(false);

    const handleClickOpen = () => {
        setOpenWarning(true);
      };
    
      const handleClose = () => {
        setOpenWarning(false);
      };

    const handleCancelConfirm = () => {
        setOpenWarning(false);
        handleCancel();
    }

    return (
        <>
            {
                !data?.clientSecret && (
                    <Loading />
                )
            }
            {
                
                (!!data?.clientSecret) && (

                    <>
                        <Dialog 
                            maxWidth="sm" 
                            open 
                            fullWidth
                            PaperProps={{
                                sx: {
                                    position: 'relative', 
                                },
                            }}
                        >
                            <CancelButton
                                onClick={handleClickOpen}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </CancelButton>

                            <EmbeddedCheckoutProvider
                                stripe={stripePromise}
                                options={{ clientSecret: data.clientSecret, onComplete: () => handleStripePaymentComplete(data.clientReferenceId) }}
                                // the oncomplete can go back and call the actual submit of the other form.....
                            >
                                <EmbeddedCheckout />
                                {/* <StripePaymentForm /> */}
                            </EmbeddedCheckoutProvider>
                        </Dialog>
                        
                        <Dialog
                            open={openWarning}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">
                                {"Are you sure?"}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Do not close this window if payment has been submitted and is loading.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button 
                                    onClick={handleClose}
                                >
                                    Return To Payment
                                </Button>
                                <Button 
                                    onClick={handleCancelConfirm}
                                    autoFocus
                                >
                                    Cancel Payment
                                </Button>
                            </DialogActions>
                        </Dialog>

                    </>
                    
                )
            }
        </>
    )
}

export default StripePayment;